import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseExpense } from '../../data/types';

export type CaseExpenseState = {
    expenses: CaseExpense[],
}

export const useCaseExpenseState = () => {
    const expenseState = useSelector((state: RootState | any) => state.caseExpenses as CaseExpenseState);
    return expenseState;
}

// Define the initial state using that type
const initialState: CaseExpenseState = {
    expenses: [],
}

export const caseExpenseSlice = createSlice({
    name: 'caseExpenses',
    initialState: initialState,
    reducers: {
        setCaseExpensesAction: (state, action: PayloadAction<CaseExpense[]>) => {
            state.expenses = action.payload;
        },
        addOrReplaceCaseExpenseAction: (state, action: PayloadAction<CaseExpense>) => {
            const existingIndex = state.expenses.findIndex((expense: CaseExpense) => expense?.expenseId === action.payload.expenseId);
            if (existingIndex >= 0) {
                state.expenses[existingIndex] = action.payload;
            } else {
                state.expenses.push(action.payload);
            }
        },
        deleteCaseExpenseAction: (state, action: PayloadAction<string>) => {
            state.expenses = state.expenses.filter((x) => x.expenseId !== action.payload);
        },
        deleteCaseExpensesAction: (state, action: PayloadAction<string[]>) => {
            state.expenses = state.expenses.filter((x) => x.expenseId && !action.payload.includes(x.expenseId));
        },
    }
})

export const { addOrReplaceCaseExpenseAction, setCaseExpensesAction, deleteCaseExpenseAction, deleteCaseExpensesAction } = caseExpenseSlice.actions;
export default caseExpenseSlice.reducer;